<script lang="ts" setup>
const props = defineProps<{
    value: string;
}>();
const emits = defineEmits(["selected", "close"]);

const PhoneCarriers = {
    SK: { value: "SK", text: "SK telecom", icon: "/images/carriers/sk1.webp" },
    KT: { value: "KT", text: "KT", icon: "/images/carriers/kt1.webp" },
    LGU: { value: "LGU", text: "LG U+", icon: "/images/carriers/lg1.png" },
    ALT_SK: { value: "ALT SK", text: "SK telecom 알뜰폰", icon: "/images/carriers/sk.webp" },
    ALT_KT: { value: "ALT KT", text: "KT 알뜰폰", icon: "/images/carriers/kt.webp" },
    ALT_LGU: { value: "ALT LGU", text: "LG U+ 알뜰폰", icon: "/images/carriers/lg.webp" },
};

const handleSelect = (value: string) => {
    emits("selected", value);
    handleClose();
};

const handleClose = () => {
    emits("close");
};
</script>
<template>
    <div class="acount-form">
        <el-dialog :model-value="true" align-center :show-close="false" @update:model-value="handleClose">
            <template #header>
                <p class="text-secondary text-xl">통신사 선택</p>
            </template>
            <div class="grid grid-cols-3 gap-4">
                <template v-for="(carrier, key) in Object.values(PhoneCarriers)" :key="key">
                    <div
                        class="carrier-item"
                        :class="carrier.value == value ? 'is-active' : ''"
                        @click="handleSelect(carrier.value)"
                    >
                        <img :src="carrier.icon" :alt="carrier.value" />
                    </div>
                </template>
            </div>
        </el-dialog>
    </div>
</template>
